export const DESKTOP_LAYERS = Object.freeze({
  search: 1200,
  taskbar: 1300,
  windowBase: 3000,
  floatingUtility: 5000,
  systemPanel: 6000,
  commandCenter: 8000,
  lockScreen: 9000,
})
